import { render, staticRenderFns } from "./refComponentCard.vue?vue&type=template&id=0bcd37e4"
import script from "./refComponentCard.vue?vue&type=script&lang=js"
export * from "./refComponentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports